'use client'

import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface LoadingSkeletonProps {
  className?: string
  variant?: 'text' | 'avatar' | 'card' | 'button' | 'image'
  width?: string | number
  height?: string | number
  animate?: boolean
}

export default function LoadingSkeleton({
  className,
  variant = 'text',
  width,
  height,
  animate = true,
}: LoadingSkeletonProps) {
  const baseClasses = 'bg-muted animate-pulse rounded'
  
  const variantClasses = {
    text: 'h-4 w-full',
    avatar: 'h-12 w-12 rounded-full',
    card: 'h-32 w-full',
    button: 'h-10 w-20',
    image: 'h-48 w-full',
  }

  const skeletonClasses = cn(
    baseClasses,
    variantClasses[variant],
    className
  )

  const style = {
    width: width || undefined,
    height: height || undefined,
  }

  if (!animate) {
    return <div className={skeletonClasses} style={style} />
  }

  return (
    <motion.div
      className={skeletonClasses}
      style={style}
      initial={{ opacity: 0.6 }}
      animate={{ 
        opacity: [0.6, 1, 0.6],
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    />
  )
}